import styled from 'styled-components';
import { BREAKPOINTS } from 'constants/common';

export const ErrorMessage = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: var(--errorRed);
  font-weight: 400;
`;

export const Label = styled.label`
  font-family: 'Inter';
  position: relative;
  display: block;
  font-weight: 500;
  margin-bottom: 12px;
  font-size: 14px;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    margin-bottom: 23px;
    display: inline-block;
    vertical-align: top;
    width: 50%;
  }

  /* @media (min-width: ${BREAKPOINTS.desktop}px) {
    width: 45%;
    margin-right: 5%;
  } */
`;

export const WarningMessage = styled(ErrorMessage)`
  color: var(--black);
`;

export const ShowOnTabletAndMore = styled.div`
  display: none;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    display: inherit;
  }
`;
